import {FC} from "react";
import {
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarDensitySelector
} from "@mui/x-data-grid-pro";
import {Box} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((_theme) => ({
	customToolbar: {
		display: "flex",
		gap: "10px",
		border: "0px solid"
	},
	gap: {
		flexGrow: 100
	}
}));

export const QuizzesListGridToolbar: FC = () => {
	const {classes} = useStyles();

	return (
		<GridToolbarContainer className={classes.customToolbar}>
			<GridToolbarColumnsButton
				placeholder={undefined}
				onPointerEnterCapture={undefined}
				onPointerLeaveCapture={undefined}
				onResize={undefined}
				onResizeCapture={undefined}
			/>
			<GridToolbarFilterButton {...({} as any)} />
			<GridToolbarDensitySelector
				placeholder={undefined}
				onPointerEnterCapture={undefined}
				onPointerLeaveCapture={undefined}
				onResize={undefined}
				onResizeCapture={undefined}
			/>
			<Box className={classes.gap} />
		</GridToolbarContainer>
	);
};
